// extracted by mini-css-extract-plugin
module.exports = {"container":"Clock_container__3izYx"};